import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';
import _ from "lodash";

import useUser from '../hooks/useUser';
import { formatDate } from '../helpers/formatting';

import '../App.css';

export default function MessagesForm(props) {
  const { user } = useUser();

  const [requestSubjectInvalid, setRequestSubjectInvalid] = useState(false);
  const [requestBodyInvalid, setRequestBodyInvalid] = useState(false);
  const [reminderSubjectInvalid, setReminderSubjectInvalid] = useState(false);
  const [reminderBodyInvalid, setReminderBodyInvalid] = useState(false);
  const [thanksPositiveSubjectInvalid, setThanksPositiveSubjectInvalid] = useState(false);
  const [thanksPositiveBodyInvalid, setThanksPositiveBodyInvalid] = useState(false);
  const [thanksNegativeSubjectInvalid, setThanksNegativeSubjectInvalid] = useState(false);
  const [thanksNegativeBodyInvalid, setThanksNegativeBodyInvalid] = useState(false);

  const handleValidateChange = (e) => {
    const setInvalid = eval('set'+_.upperFirst(e.target.name)+'Invalid');
    if (!e.target.value) {
      setInvalid(true);
      return;
    } else {
      setInvalid(false);
    }
  }

  return (
    <Container fluid className="text-start mt-3 mt-md-5">
      <Row>
        <Col></Col>
        <Col xs={12} sm={8}>

          <Card className="mb-3">
            <Card.Body>
              <Card.Title>Request Email</Card.Title>
              <p>
                This is the first email we send after a repair order is closed.
              </p>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control 
                    isInvalid={requestSubjectInvalid} 
                    type="text" 
                    name="requestSubject" 
                    defaultValue={props.requestSubject ? props.requestSubject : (user ? user.shop.data.saastic_account.data.request_email_subject : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a subject.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Body</Form.Label>
                  <Form.Control 
                    as="textarea"
                    isInvalid={requestBodyInvalid} 
                    type="text" 
                    name="requestBody" 
                    defaultValue={props.requestBody ? props.requestBody : (user ? user.shop.data.saastic_account.data.request_email_body : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a message.
                  </Form.Control.Feedback>                  
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
          
          <Card className="mb-3">
            <Card.Body>
              <Card.Title>Reminder Email</Card.Title>
              <p>
                This is the reminder email we send a week after the initial request email. 
              </p>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control 
                    isInvalid={reminderSubjectInvalid} 
                    type="text" 
                    name="reminderSubject" 
                    defaultValue={props.reminderSubject ? props.reminderSubject : (user ? user.shop.data.saastic_account.data.reminder_email_subject : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a subject.
                  </Form.Control.Feedback>                      
                </Form.Group>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Body</Form.Label>
                  <Form.Control 
                    as="textarea"
                    isInvalid={reminderBodyInvalid} 
                    type="text" 
                    name="reminderBody" 
                    defaultValue={props.reminderBody ? props.reminderBody : (user ? user.shop.data.saastic_account.data.reminder_email_body : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a message.
                  </Form.Control.Feedback>                  
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
          
          <Card className="mb-3">
            <Card.Body>
              <Card.Title>Thanks Email: Positive Feedback</Card.Title>
              <p>
                This is the thank you email we send when a customer leaves a positive review. 
              </p>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control 
                    isInvalid={thanksPositiveSubjectInvalid} 
                    type="text" 
                    name="thanksPositiveSubject" 
                    defaultValue={props.thanksPositiveSubject ? props.thanksPositiveSubject : (user ? user.shop.data.saastic_account.data.thanks_pos_email_subject : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a subject.
                  </Form.Control.Feedback>                      
                </Form.Group>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Body</Form.Label>
                  <Form.Control 
                    as="textarea"
                    isInvalid={thanksPositiveBodyInvalid} 
                    type="text" 
                    name="thanksPositiveBody" 
                    defaultValue={props.thanksPositiveBody ? props.thanksPositiveBody : (user ? user.shop.data.saastic_account.data.thanks_pos_email_body : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a message.
                  </Form.Control.Feedback>                  
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
          
          <Card>
            <Card.Body>
              <Card.Title>Thanks Email: Negative Feedback</Card.Title>
              <p>
                This is the thank you email we send when a customer leaves a negative review. 
              </p>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control 
                    isInvalid={thanksNegativeSubjectInvalid} 
                    type="text" 
                    name="thanksNegativeSubject" 
                    defaultValue={props.thanksNegativeSubject ? props.thanksNegativeSubject : (user ? user.shop.data.saastic_account.data.thanks_neg_email_subject : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a subject.
                  </Form.Control.Feedback>                      
                </Form.Group>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Body</Form.Label>
                  <Form.Control 
                    as="textarea"
                    isInvalid={thanksNegativeBodyInvalid} 
                    type="text" 
                    name="thanksNegativeBody" 
                    defaultValue={props.thanksNegativeBody ? props.thanksNegativeBody : (user ? user.shop.data.saastic_account.data.thanks_neg_email_body : '')}
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a message.
                  </Form.Control.Feedback>                  
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>

        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
}
